module.exports = __webpack_public_path__ + "static/media/01_360.7bd84c73.jpeg";